// /**
//  * 描述：获取商户配置信息，由于腾慧和珊瑚两个平台的网校都用该套代码，所以获取配置需要根据平台类型做兼容处理
// **/
// import Vue from 'vue'
// import axios from 'axios'
// import store from "@/store/store"
// import GLOBAL_CONFIG from '../../config/index'

// /**
//  * 描述：获取珊瑚配置信息
// **/
// export const getShanhuOrgConfig = () => {
//     // 先读取腾讯默认配置
//     const getDefaultConfig = axios.get(`${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/miniConfig.json?a=${new Date().valueOf()}`)
//     // 读取机构单独的配置文件
//     const uId = store.getters['user/getOrgId']
//     const orgConfig = axios.get(`${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/userConfig/${uId}.json?a=${new Date().valueOf()}`)
//     return {
//         getDefaultConfig,
//         orgConfig
//     }
// }

// /**
//  * 描述：获取腾慧配置信息
// **/
// export const getTengfaceOrgConfig = () => {
//     // 先读取阿里默认配置
//     const getDefaultConfig = axios.get(`https://tengfaceliveuser.tengface.net/web/config/miniConfig.json?a=${new Date().valueOf()}`)
//     // 读取机构单独的配置文件
//     const uId = store.getters['user/getOrgId']
//     const orgConfig = axios.get(`https://tengfaceliveuser.tengface.net/web/config/userConfig/${uId}.json?a=${new Date().valueOf()}`)
//     return {
//         getDefaultConfig,
//         orgConfig
//     }
// }

// export const getPrefixHost = (uid) => {
//     let hostURL = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o']
//     let prefix = ''
//     String(uid).split('').forEach(item => {
//         prefix += hostURL[item]
//     })
//     return prefix    
// }


// /**
//  * 描述：获取机构配置
// **/
// export const useOrgConfig = () => {
//     return new Promise((resolve, reject) => {
//         let getRequestBody
//         const isShanhu = store.getters['user/getIsShanhuState']
//         if(isShanhu) {
//             getRequestBody = getShanhuOrgConfig
//         } else {
//             getRequestBody = getTengfaceOrgConfig
//         }
//         const { getDefaultConfig, orgConfig } = getRequestBody()
//         // 请求后合并配置
//         Promise.allSettled([getDefaultConfig, orgConfig]).then(async (res) => {
//             try {
//                 let defaultConfig = {}
//                 const uId = store.getters['user/getOrgId']
//                 if(res[0].status === 'fulfilled') {
//                     defaultConfig = res[0].value.data || {}
//                     if (defaultConfig.wx_h5_web_url) {
//                         defaultConfig.wx_h5_url = defaultConfig.wx_h5_web_url
//                     }
//                     if (isShanhu && defaultConfig.wx_h5_main_host) {
//                         defaultConfig.wx_h5_url = `https://${getPrefixHost(uId)}.${defaultConfig.wx_h5_main_host}`
//                     }
//                 }
//                 let orgConfig = {}
//                 if(res[1].status === 'fulfilled') {
//                     orgConfig = res[1].value.data || {}
//                     if (orgConfig && orgConfig.wx_h5_host_prefix && defaultConfig.wx_h5_main_host) { // 主域名用户配置域名前缀
//                         let wx_h5_url = `https://${getPrefixHost(uId)}x${orgConfig.wx_h5_host_prefix}.${defaultConfig.wx_h5_main_host}`
//                         defaultConfig.wx_h5_url = wx_h5_url
//                     }
//                 }
//                 const levelConfig = await useOrgLevelConfig()
//                 // 如果机构有自定义配置，则优先自定义配置，所以把机构放最后面，当机构自定的配置没有的时候，就读取公共配置
//                 const mergeConfig = { ...defaultConfig, ...levelConfig, ...orgConfig }
//                 resolve(mergeConfig)
//             } catch (error) {
//                 reject({code: 0, data: error})
//             }
//         }).catch(err => {
//             reject(err)
//         })
//     })
// }

// export function useOrgLevelConfig() {
//     return new Promise((resolve, reject) => {
//         Vue.prototype.$liveApi.post(`/liveapi/customer/index/getBindOrgLevel`, {
//             org_id: store.getters['user/getOrgId']
//         }).then(({ data: { code, data: resLevelInfo } }) => {
//             if(code === 200) {
//                 let levelConfig = {}
//                 resLevelInfo = resLevelInfo || {}
//                 if(resLevelInfo.domain) {
//                     levelConfig.follow_web_url = resLevelInfo.domain
//                     levelConfig.wx_h5_url = resLevelInfo.domain
//                 }
//                 if(resLevelInfo.app_id) {
//                     levelConfig.mp_login_appid = resLevelInfo.app_id
//                     levelConfig.mp_1v1_login_appid = resLevelInfo.app_id
//                 }
//                 if(resLevelInfo.original_id) {
//                     levelConfig.mp_1v1_login_orgin_id = resLevelInfo.original_id
//                 }
//                 if(resLevelInfo.url) {
//                     levelConfig.wx_qrcode_webview_url = resLevelInfo.url
//                 }
//                 if(resLevelInfo.login_auth_url) {
//                     levelConfig.login_auth_url = resLevelInfo.login_auth_url
//                 }
//                 resolve(levelConfig)
//             } else {
//                 reject({})
//             }
//         })
//     })
// }

import Vue from 'vue'
import axios from 'axios'
import store from "@/store/store"

export function useOrgConfig() {
    return new Promise((resolve) => {
        const uId = store.getters['user/getOrgId']
        axios.get(`https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com/uid/more/${uId}.json?a=${new Date().valueOf()}`,{timeout:5000}).then(({ status, data }) => {
            if(status === 200) {
                resolve(data)
            } else {
                resolve({})
            }
        }).catch(() => {
            Vue.prototype.$liveApi.get(`/liveapi/api/init/qryTypeConfig?org_id=${uId}`).then(({ data: { code, data } }) => {
                if(code === 200) {
                    resolve(data)
                } else {
                    resolve({})
                }
            })
        })
    })
}